import { ParcelStatus } from "../AddParcel/types";

export interface IParcel {
  id: string;
  parcelNumber: string;
  pickupLocationId: string;
  pickupLocation: {
    id: string;
    locationId: string;
    location: {
      id: string;
      name: string;
    };
  };
  userId: string;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    status: string;
  };
  deliveryTime: string;
  pickupTime: string;
  deliveryCode: string;
  pickupCode: string;
  deliveryCompany: string;
  parcelStatus: ParcelStatus;
  parcelImage: [
    {
      id: string;
      name: string;
      imageUrl: string;
    }
  ];
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface IParcelRes {
  data: IParcel;
}

export interface IParcelsRes {
  data: IParcel[];
  count: number;
}



export enum Status {
  Active = "Active",
  Inactive = "Inactive",
  Delete = "Delete",
}
export enum ParcelStatuses {
  InStorage = "InStorage",
  Issued = "Issued",
  Returned = "Returned",
}